export const CREATE_ORGANIZATION_REQ = 'CREATE_ORGANIZATION_REQ';
export const CREATE_ORGANIZATION_OK = 'CREATE_ORGANIZATION_OK';
export const CREATE_ORGANIZATION_ERR = 'CREATE_ORGANIZATION_ERR';

export const UPDATE_ORGANIZATION_REQ = 'UPDATE_ORGANIZATION_REQ';
export const UPDATE_ORGANIZATION_OK = 'UPDATE_ORGANIZATION_OK';
export const UPDATE_ORGANIZATION_ERR = 'UPDATE_ORGANIZATION_ERR';

export const REMOVE_ORGANIZATION_REQ = 'REMOVE_ORGANIZATION_REQ';
export const REMOVE_ORGANIZATION_OK = 'REMOVE_ORGANIZATION_OK';
export const REMOVE_ORGANIZATION_ERR = 'REMOVE_ORGANIZATION_ERR';

export const ADD_ORGANIZATION_MEMBER_REQ = 'ADD_ORGANIZATION_MEMBER_REQ';
export const ADD_ORGANIZATION_MEMBER_OK = 'ADD_ORGANIZATION_MEMBER_OK';
export const ADD_ORGANIZATION_MEMBER_ERR = 'ADD_ORGANIZATION_MEMBER_ERR';

export const REMOVE_ORGANIZATION_MEMBER_REQ = 'REMOVE_ORGANIZATION_MEMBER_REQ';
export const REMOVE_ORGANIZATION_MEMBER_OK = 'REMOVE_ORGANIZATION_MEMBER_OK';
export const REMOVE_ORGANIZATION_MEMBER_ERR = 'REMOVE_ORGANIZATION_MEMBER_ERR';

export const VERIFY_ORGANIZATION_MEMBER_REQ = 'VERIFY_ORGANIZATION_MEMBER_REQ';
export const VERIFY_ORGANIZATION_MEMBER_OK = 'VERIFY_ORGANIZATION_MEMBER_OK';
export const VERIFY_ORGANIZATION_MEMBER_ERR = 'VERIFY_ORGANIZATION_MEMBER_ERR';
